import axios from "axios";
import { Dispatch } from "redux";
import { baseUrl } from "../api";
import { setBookerProfile, setLandlordProfile } from ".";
import { emit } from "@/src/hooks/useListener";
import { ALERT_EVENTS } from "@/src/lib/constants";
import { updateBooker, updateLandlord } from "./interface";


export const getLandLordRequest =()=>async(dispatch:Dispatch)=>{
    try {
        const response = await axios.get(`${baseUrl.users}/landlord`)
        
        dispatch(setLandlordProfile(response.data))
        
    } catch (error) {
        console.log(error);
        
    }
}
export const getBookerRequest =()=>async(dispatch:Dispatch)=>{
    try {
        const response = await axios.get(`${baseUrl.users}/booker`)
        dispatch(setBookerProfile(response.data))
        
    } catch (error) {
        console.log(error);
        
    }
}

// UpdateLandlord thunk for PATCH request with error handling and alert emission
export const updateLandLordRequest = (landlordId:string, body:updateLandlord) => async (dispatch: Dispatch) => {
    try {
        const response = await axios.patch(`${baseUrl.users}/landlord/${landlordId}`, body);
        emit(ALERT_EVENTS.SUCCESS, "User Updated Sucessfully")
        dispatch(setLandlordProfile(response.data));
    } catch (error:any) {
        let errorMsg = "An error occurred";
        if (error.response && error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
        } else if (error.message) {
            errorMsg = error.message;
        }
        emit(ALERT_EVENTS.ERROR, errorMsg);
    }
};
export const updateBookerRequest = (landlordId:string, body:updateBooker) => async (dispatch: Dispatch) => {
    try {
        const response = await axios.patch(`${baseUrl.users}/booker/${landlordId}`, body);
        emit(ALERT_EVENTS.SUCCESS, "User Updated Sucessfully")
        dispatch(setBookerProfile(response.data));
    } catch (error:any) {
        let errorMsg = "An error occurred";
        if (error.response && error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
        } else if (error.message) {
            errorMsg = error.message;
        }
        emit(ALERT_EVENTS.ERROR, errorMsg);
    }
};

export const sendHomeEmail =(email:string, message:string)=> async(dispatch:Dispatch)=>{
    try {
        const response = await axios.post(`${baseUrl.users}/send-email`, {email, message});
        emit(ALERT_EVENTS.SUCCESS, "Email Sent Successfully ")
        dispatch(setBookerProfile(response.data));
    } catch (error:any) {
        let errorMsg = "An error occurred";
        if (error.response && error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
        } else if (error.message) {
            errorMsg = error.message;
        }
        emit(ALERT_EVENTS.ERROR, errorMsg);
    }    
}